module.exports = __webpack_public_path__ + "static/media/mitocondria.e54cfa84.gif";